export default __webpack_public_path__ + "locales/de/About.json?hash=e7e69b9c2ca9e28e2e17574e4318fb20";